import { useAuth } from 'react-oidc-context';
import { useCallback } from 'react';
import { OIDC_LOGOUT_URL, OIDC_LOGOUT_RETURN_TO } from '@/lib/env';

export function useLogout() {
  const auth = useAuth();

  const logout = useCallback(async () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('accessToken');
    }
    try {
      if (auth.isAuthenticated) {
        await auth.signoutRedirect();
      } else {
        await auth.removeUser();
        const logoutUrl = OIDC_LOGOUT_URL;
        const returnTo = OIDC_LOGOUT_RETURN_TO;
        if (logoutUrl) {
          window.location.href = `${logoutUrl}?post_logout_redirect_uri=${encodeURIComponent(returnTo)}`;
        } else {
          window.location.href = '/signout';
        }
      }
    } catch (error) {
      console.error('Error during signout redirect:', error);
      await auth.removeUser();
      if (typeof window !== 'undefined') {
        window.location.href = '/signout';
      }
    }
  }, [auth]);

  return { logout };
}
